export const FETCH_BILLING_ENTITY_METRICS_REQUEST = 'BILLINGS/GLOBAL/FETCH_REQUEST';

export const EXPORT_BILLING_REQUEST = 'BILLINGS/EXPORT/REQUEST';

export const SET_BILLING_DASHBOARD_FILTER = 'BILLINGS/DASHBOARD/FILTER/SET';
export const SET_BILLING_DASHBOARD_FILTERS = 'BILLINGS/DASHBOARD/FILTERS/SET';
export const CLEAR_BILLING_DASHBOARD_FILTER = 'BILLINGS/DASHBOARD/FILTERS/CLEAR';
export const REMOVE_BILLING_DASHBOARD_FILTER = 'BILLINGS/DASHBOARD/FILTERS/REMOVE';

export const SET_DOCUMENTS_TAB = 'BILLINGS/DOCUMENTS/TAB/SET';
